export const generateErrorMessages = (validatorValue: any) => {
  return {
    required: 'Este campo é obrigatório',
    email: 'Digite um endereço de email válido',
    invalidPassword: `A senha precisa ter pelo menos 8 caracteres, sendo, 1 caractere especial, 1 caractere maiúsculo, 1 caractere minúsculo, 1 número.`,
    invalidPasswordOld: `A senha precisa ter pelo menos 5 caractéres e conter um número`,
    minlength: `Tamanho mínimo de ${validatorValue.requiredLength} caractéres`,
    maxlength: `Tamanho máximo de ${validatorValue.requiredLength} caractéres`,
    maxFiles: `O limite de arquivos anexos para este campo é ${validatorValue.maxFile}.`,
    invalidMatch: 'As senhas digitadas não conferem. Por favor, verifique.',
    onlyAlphaCharacters: 'Este campo somente pode conter letras',
    invalidCPF: 'O CPF digitado não é válido',
    dateInvalid: 'Data Inválida',
    noFutureDate: 'Data não pode ser futura',
    ageNotLessThan: `Idade não pode ser inferior à ${validatorValue.minAge} ano(s)`,
  };
};
